import { Card, Typography } from "antd";
import React from "react";
import { TableDuplicateData } from "./TableDuplicateData/TableDuplicateData";

const { Text } = Typography;

// Satu klaster duplikat: data asli (id terkecil) di baris pertama,
// duplikatnya di bawahnya, dengan aksi per baris yang sama seperti sebelumnya.
export const DuplicateClusterCard = ({
  cluster,
  rowSelection,
  isLoading,
  isDetail,
  onShowModalDetail,
}) => {
  const rows = [cluster.origin, ...cluster.duplicates];

  return (
    <Card
      className="duplicate-cluster-card"
      size="small"
      title={
        <Text strong>
          {cluster.origin.father_name || "-"} &amp;{" "}
          {cluster.origin.mother_name || "-"}
        </Text>
      }
      extra={<Text type="secondary">{rows.length} data</Text>}
    >
      <TableDuplicateData
        compact
        dataSource={rows}
        isDetail={isDetail}
        rowSelection={rowSelection}
        isLoading={isLoading}
        onShowModalDetail={onShowModalDetail}
      />
    </Card>
  );
};
